import { createStore, compose, applyMiddleware } from 'redux';
import thunk from 'redux-thunk'
import rootReducer from '../reducers';

export default function configureStore(initialState) {
  return createStore(rootReducer, initialState, compose(
      applyMiddleware(thunk)
    )
  );
}



/** WEBPACK FOOTER **
 ** ./src/store/configureStore.prod.js
 **/